import styled, { css } from 'styled-components';
import { palette, theme } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights } from '../../utils/typography';
import { OptionalBackgroundButton } from '../Button';

export const Inner = styled.div`
	height: 100%;
	width: 100%;
	padding: 8px 16px;
	border-radius: 4px;
	line-height: normal;
	position: relative;
	display: inline-flex;
	justify-content: center;
	align-items: center;
`;

export const Wrapper = styled(OptionalBackgroundButton)<{
	$backgroundColor: string;
	$textColor: string;
	$iconColor: string;
	$asCard: boolean;
	$leftEdgeColor: string;
	$isVisible: boolean;
	$fromTop: boolean;
}>`
	background: ${p => palette(p.$backgroundColor)(p) ?? p.$backgroundColor};
	border-radius: 4px;
	box-shadow: ${theme('toasts.shadow')};
	color: ${p => palette(p.$textColor)(p) ?? p.$textColor};
	${fontSize(FontSizes.sm)}
	${fontWeight(FontWeights.Medium)}
  line-height: normal;
	left: 50%;
	min-height: 0;
	opacity: ${p => (p.$isVisible ? 1 : 0)};
	padding: 0;
	position: absolute;
	${p => (p.$fromTop ? 'top: 24px' : 'bottom: 24px')};
	transform: translate3d(-50%, ${p => (p.$isVisible ? '0' : p.$fromTop ? '-4px' : '4px')}, 0);
	transition: ${theme('animation.transition')};
	visibility: ${p => (p.$isVisible ? 'visible' : 'hidden')};
	z-index: ${theme('toasts.zIndex')};

	& svg {
		height: 20px;
		margin-right: 8px;
		width: 20px;

		& path {
			fill: ${p => palette(p.$iconColor)(p) ?? p.$iconColor};
		}
	}

	${p => {
		if (!p.$asCard) {
			return '';
		}
		return css`
			border: ${p.theme.toasts.cardHasBorder ? `1px solid ${palette('toastCardBorderColor')(p)}` : 'none'};

			${Inner} {
				padding: 16px 8px;
				padding-left: calc(8px + 4px);
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					height: 100%;
					width: 4px;
					background: ${palette(p.$leftEdgeColor)(p) ?? p.$leftEdgeColor};
					border-top-left-radius: 3px;
					border-bottom-left-radius: 3px;
				}
			}
		`;
	}}
`;
